import {Modal} from "bootstrap"
import prepareAjaxForm from "./lib/prepare-ajax-form"


const form = document.getElementById('report-review-form')
const reportBtns = document.querySelectorAll('.report-review-btn')
if (form && reportBtns.length > 0) {
    const modalElement = document.getElementById('report-review-form-modal')
    const modal = new Modal(modalElement)
    const formElementContainer = form.querySelector('.form-element-container')
    const spinner = form.querySelector('.spinner')
    const errorMsg = form.querySelector('.error-msg')
    const reasonInput = document.getElementById('report-reason')
    const detailsInput = document.getElementById('report-details')
    prepareAjaxForm(form)
    reasonInput.addEventListener('change', () => {
        const isDetailsRequired = reasonInput.value === 'other'
        if (isDetailsRequired) {
            detailsInput.setAttribute('required', 'required')
        } else {
            detailsInput.removeAttribute('required')
        }
    })
    reportBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            form.reset()
            form.action = btn.dataset.formAction
            formElementContainer.classList.remove('hidden')
            errorMsg.classList.add('hidden')
            spinner.classList.add('hidden')
            modal.show()
        })
    })
}
